"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import UiForm, {
  UiFormController
} from "@/components/form/UiForm.vue";
import { Debounce } from "vue-debounce-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
import UiSubmit from "@/components/form/UiSubmit.vue";
import { MAIN_WEBSOCKET } from "@/configuration/websocketskey";
class ScreenShot extends UiFormController {
  constructor() {
    super(...arguments);
    this.screen_switch = false;
    this.screen_open_list = ["management", "browser"];
    this.screen_show_content = "";
  }
}
let DataSafety = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.screenController = new ScreenShot();
    this.choose_account = "member_name";
    this.choose_show_list = [
      {
        value: "management",
        label: this.$t("data_safety.screen_show_manager")
      },
      {
        value: "browser",
        label: this.$t("data_safety.screen_show_environment")
      }
    ];
    this.choose_account_options = [
      {
        value: "member_name",
        label: this.$t("data_safety.choose_account_option_1")
      },
      {
        value: "team_name",
        label: this.$t("data_safety.choose_account_option_2")
      },
      {
        value: "no_content",
        label: this.$t("data_safety.choose_account_option_3")
      }
    ];
    this.choose_number = "phone_last_4";
    this.choose_number_options = [
      {
        value: "phone_last_4",
        label: this.$t("data_safety.choose_number_option_1")
      },
      {
        value: "number",
        label: this.$t("data_safety.choose_number_option_2")
      },
      {
        value: "mac_address_lase_4",
        label: this.$t("data_safety.choose_number_option_3")
      },
      {
        value: "no_content",
        label: this.$t("data_safety.choose_number_option_4")
      }
    ];
    this.wartermark_content = "";
    this.opacity_value = 100;
  }
  mounted() {
    return __async(this, null, function* () {
      try {
        yield this.wartMarkConfig();
        yield this.getScreenInfo();
      } catch (error) {
      }
    });
  }
  wartMarkConfig() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(`api://base.auth/api/v1/watermark-config`);
        let show_arr = [];
        let account_name_arr = [];
        let choose_number_arr = [];
        for (const show_contet of response.data.show) {
          let checkbox = {
            "value": show_contet,
            "label": ""
          };
          if (show_contet === "management") {
            checkbox.label = this.$t("data_safety.screen_show_manager");
          }
          if (show_contet === "browser") {
            checkbox.label = this.$t("data_safety.screen_show_environment");
          }
          show_arr.push(checkbox);
        }
        this.choose_show_list = show_arr;
        for (const choose_account of response.data.content.firstPart) {
          let account_option = {
            "value": choose_account,
            "label": ""
          };
          if (choose_account === "member_name") {
            account_option.label = this.$t("data_safety.choose_account_option_1");
          }
          if (choose_account === "team_name") {
            account_option.label = this.$t("data_safety.choose_account_option_2");
          }
          if (choose_account === "no_content") {
            account_option.label = this.$t("data_safety.choose_account_option_3");
          }
          account_name_arr.push(account_option);
        }
        this.choose_account_options = account_name_arr;
        for (const choose_number of response.data.content.secondPart) {
          let choose_number_item = {
            "value": choose_number,
            "label": ""
          };
          if (choose_number === "phone_last_4") {
            choose_number_item.label = this.$t("data_safety.choose_number_option_1");
          }
          if (choose_number === "number") {
            choose_number_item.label = this.$t("data_safety.choose_number_option_2");
          }
          if (choose_number === "mac_address_lase_4") {
            choose_number_item.label = this.$t("data_safety.choose_number_option_3");
          }
          if (choose_number === "no_content") {
            choose_number_item.label = this.$t("data_safety.choose_number_option_4");
          }
          choose_number_arr.push(choose_number_item);
        }
        this.choose_number_options = choose_number_arr;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getScreenInfo() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(`api://base.auth/api/v1/watermark`);
        this.screenController.screen_open_list = response.data.show ? response.data.show : [];
        this.screenController.screen_switch = response.data.open;
        this.choose_account = response.data.content.firstPart;
        this.choose_number = response.data.content.secondPart;
        this.wartermark_content = response.data.content.thirdPart;
        this.opacity_value = response.data.transparency ? response.data.transparency : 100;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  canvasWM(text) {
    try {
      let content = {
        container: document.body,
        width: "600px",
        height: "400px",
        textAlign: "left",
        textBaseline: "middle",
        font: "20px Microsoft Yahei",
        fillStyle: "rgba(184,184,184,0.6)",
        text,
        rotate: -30,
        zIndex: 1e4
      };
      const canvas = document.createElement("canvas");
      canvas.setAttribute("width", content.width);
      canvas.setAttribute("height", content.height);
      const ctx = canvas.getContext("2d");
      ctx.textAlign = content.textAlign;
      ctx.textBaseline = content.textBaseline;
      ctx.font = content.font;
      ctx.fillStyle = content.fillStyle;
      ctx.rotate(Math.PI / 180 * content.rotate);
      ctx.fillText(
        content.text,
        20,
        360
      );
      const base64url = canvas.toDataURL();
      const _wm = document.querySelector(".__wm");
      const watermarkDiv = _wm || document.createElement("div");
      const styleStr = `position:fixed;top:0;left:0;bottom:0;width:100%;height:100%;z-index:${content.zIndex};pointer-events:none;background-repeat:repeat;background-image:url(${base64url});opacity:${(this.opacity_value / 100).toFixed(2)};`;
      watermarkDiv.setAttribute("style", styleStr);
      watermarkDiv.classList.add("__wm");
      if (!_wm) {
        content.container.insertBefore(
          watermarkDiv,
          content.container.firstChild
        );
      }
      content.container.appendChild(watermarkDiv);
    } catch (error) {
      console.log(error);
    }
  }
  screenSubmit() {
    return __async(this, null, function* () {
      try {
        let form_data = {
          "open": this.screenController.screen_switch,
          "show": this.screenController.screen_open_list,
          "content": {
            "firstPart": this.choose_account,
            "secondPart": this.choose_number,
            "thirdPart": this.wartermark_content
          },
          "transparency": this.opacity_value
        };
        yield API.post(`api://base.auth/api/v1/watermark`, form_data);
        yield API.post(`api://base.local/websockets/${MAIN_WEBSOCKET}`, {
          "model": "screenImage.change",
          "value": {
            "message": "change.screenImage.success"
          }
        });
        this.$message.success(this.$t("data_safety.save_success_tip"));
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  showWarterMark() {
    return __async(this, null, function* () {
      try {
        const result = yield API.get(`api://base.auth/api/v1/user-watermark`);
        if (result.data.open) {
          let content = result.data.content.firstPart + result.data.content.secondPart + (result.data.content.thirdPart === null ? "" : result.data.content.thirdPart);
          this.canvasWM(content);
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  formatTooltip(data) {
    return `${data}%`;
  }
};
__decorateClass([
  Debounce(400)
], DataSafety.prototype, "screenSubmit", 1);
__decorateClass([
  Debounce(800)
], DataSafety.prototype, "showWarterMark", 1);
DataSafety = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit
    }
  })
], DataSafety);
export {
  DataSafety as default
};
